import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Set from "@babel/runtime-corejs2/core-js/set";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import { useCallback, useState, useEffect, useRef } from 'react';
import { useDebounce } from '@dmi-mch/utils';
/* This hooks will perform some logic to create a list of items which are selected  */

function useSearchDropdownSelector(props, handleSearchResult) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      userInputValue = _useState2[0],
      setUserInputValue = _useState2[1];

  var debouncedSearchTerm = useDebounce(userInputValue, 500);
  var searchTerm = useRef(null);
  var name = props.name,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {} : _props$setFieldValue,
      fieldName = props.fieldName,
      defaultValue = props.defaultValue;
  var defaultLists = {
    selectedMultipleValues: defaultValue || [],
    listForRender: defaultValue
  };

  var _useState3 = useState(defaultLists),
      _useState4 = _slicedToArray(_useState3, 2),
      lists = _useState4[0],
      setLists = _useState4[1];

  useEffect(function () {
    if (defaultValue) {
      var defaultListsNew = {
        selectedMultipleValues: defaultValue,
        listForRender: defaultValue
      };
      setLists(defaultListsNew);
      searchTerm.current = null;
    }
  }, [defaultValue]); // Default OnChange function from the component

  var handleChange = function handleChange(event, data) {
    var latestAddition = data.value.slice(-1).pop();
    var latestAdditionJSON = lists.listForRender.find(function (item) {
      return item.value === latestAddition;
    });
    var isFound = lists.selectedMultipleValues.find(function (item) {
      return item.value === latestAddition;
    });

    var newLists = _objectSpread({}, lists);

    if (latestAdditionJSON && !isFound) {
      newLists.selectedMultipleValues = [].concat(_toConsumableArray(lists.selectedMultipleValues), [latestAdditionJSON]);
      setLists(newLists);
      setFieldValue(fieldName, newLists.selectedMultipleValues);
    } else {
      // Remove if not in the list
      lists.selectedMultipleValues.forEach(function (option) {
        if (!data.value.includes(option.value)) {
          newLists.selectedMultipleValues = _toConsumableArray(lists.selectedMultipleValues.filter(function (item) {
            return item.value !== option.value;
          }));
          setLists(newLists);
          setFieldValue(fieldName, newLists.selectedMultipleValues);
        }
      });
    }
  };

  var setSearchTerm = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var dropdownOptions, arrWithDuplicates, newLists;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return handleSearchResult(value);

            case 2:
              dropdownOptions = _context.sent;
              arrWithDuplicates = dropdownOptions && dropdownOptions.concat(lists.selectedMultipleValues);
              newLists = _objectSpread({}, lists);
              newLists.selectedMultipleValues = _toConsumableArray(lists.selectedMultipleValues);
              newLists.listForRender = _toConsumableArray(new _Set(arrWithDuplicates));
              setLists(newLists);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [handleSearchResult, lists]);
  useEffect(function () {
    if (debouncedSearchTerm && debouncedSearchTerm !== searchTerm.current) {
      setSearchTerm(debouncedSearchTerm);
      searchTerm.current = debouncedSearchTerm;
    }
  }, [debouncedSearchTerm, setSearchTerm]);
  return {
    handleChange: handleChange,
    setUserInputValue: setUserInputValue,
    name: name,
    lists: lists
  };
}

export default useSearchDropdownSelector;